import { render, staticRenderFns } from "./SalesmanOrderList.vue?vue&type=template&id=2d353296&scoped=true"
import script from "./SalesmanOrderList.vue?vue&type=script&lang=js"
export * from "./SalesmanOrderList.vue?vue&type=script&lang=js"
import style0 from "./SalesmanOrderList.vue?vue&type=style&index=0&id=2d353296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d353296",
  null
  
)

export default component.exports